import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/icon/style/index.tsx